import React, { memo, useEffect } from 'react';

import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Route } from 'react-router-dom/cjs/react-router-dom.min';

import ErrorBoundaries from 'components/ErrorBoundaries';
import DataValidation from 'containers/GlobalWrapper/DataValidation';
import Layout from 'containers/GlobalWrapper/layout';
import { useLastVisitedPage } from 'utils/localStorageUser';

import BusinessOrganizationDataValidation from '../GlobalWrapper/BusinessOrganizationDataValidation';
import ProjectDataValidation from '../GlobalWrapper/ProjectDataValidation';

function ProtectedRoute({ component: Component, ...rest }) {
  const location = useLocation();
  const [, setPage] = useLastVisitedPage();

  useEffect(
    () => {
      setPage(location.pathname);
    },
    [location.pathname, setPage],
  );

  return (
    <Route {...rest}>
      <BusinessOrganizationDataValidation>
        <ProjectDataValidation>
          <DataValidation>
            <Layout>
              <ErrorBoundaries>
                <Component />
              </ErrorBoundaries>
            </Layout>
          </DataValidation>
        </ProjectDataValidation>
      </BusinessOrganizationDataValidation>
    </Route>
  );
}

ProtectedRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default memo(ProtectedRoute);
